import { Component } from '@angular/core';

@Component({
  selector: 'iris-card-header',
  templateUrl: './iris-card-header.component.html',
  styleUrls: ['./iris-card-header.component.css'],
  standalone: false,
})
export class IrisCardHeaderComponent {}
